module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_78.60a5f229.jpg";